module.exports = __webpack_public_path__ + "img/2-2.0d9d3d3f.png";